export const tableData = {
  columns: [
    {
      headerLabel: 'Change Date/Time',
      accessor: 'dateTime',
      width: 350,
      id: 'dateTime', // REQUIRED
    },
    {
      headerLabel: 'Client Name',
      accessor: 'clientName',
      width: 350,
      id: 'clientName', // REQUIRED
    },
    {
      headerLabel: 'Assignee',
      accessor: 'assignee',
      width: 350,
      id: 'assignee', // REQUIRED
    },
    {
      headerLabel: 'Quote Reference',
      accessor: 'quoteReference',
      width: 450,
      id: 'quoteReference', // REQUIRED
    },
    {
      headerLabel: 'Booking Reference',
      accessor: 'bookingReference',
      width: 450,
      id: 'bookingReference', // REQUIRED
    },
    {
      headerLabel: 'Open tasks',
      accessor: 'openTasks',
      width: 300,
      id: 'openTasks', // REQUIRED
    },
  ],
  data: [
    {
      clientName: 'Lucie Neads',
      dateTime: new Date(1618536151000).toISOString(),
      quoteReference: '32128c32-14ff-415c-a0a0-d20b726e9671',
      bookingReference: '32128c32-14ff-415c-a0a0-d20b726e9671',
      openTasks: 'Mother (Mat)',
      assignee: 'Assignee Name1',
    },
    {
      clientName: 'Agace Garlic',
      dateTime: new Date(1626667213000).toISOString(),
      quoteReference: 'e41fcb02-e4be-4522-9ffb-7665aa08c256',
      bookingReference: '',
      openTasks: 'Tokyo.Sora',
      assignee: 'Assignee Name2',
    },
    {
      clientName: 'Roderick Maciaszek',
      dateTime: new Date(1624938075000).toISOString(),
      quoteReference: 'd5560853-9408-437c-b7a3-53fdcad44c22',
      bookingReference: 'd5560853-9408-437c-b7a3-53fdcad44c22',
      openTasks: 'Rocking Horse Winner, The',
      assignee: 'Assignee Name3',
    },
    {
      clientName: 'Doti Grzegorzewicz',
      dateTime: new Date(1614790000000).toISOString(),
      quoteReference: '',
      bookingReference: '66df59bc-00a2-4c3e-8bc5-5720f0db76a2',
      openTasks: 'Siege, The',
      assignee: 'Assignee Name4',
    },
    {
      clientName: 'Birgit Wolpert',
      dateTime: new Date(1621329532000).toISOString(),
      quoteReference: '129ac12f-29bb-4603-8dd6-a35a11404872',
      bookingReference: '129ac12f-29bb-4603-8dd6-a35a11404872',
      openTasks: 'The End',
      assignee: 'Assignee Name5',
    },
    {
      clientName: 'Swen Stetson',
      dateTime: new Date(1636291258000).toISOString(),
      quoteReference: '59dbcacb-5966-4eb4-9364-2151c7044ba5',
      bookingReference: '59dbcacb-5966-4eb4-9364-2151c7044ba5',
      openTasks: 'Curious George',
      assignee: 'Assignee Name6',
    },
    {
      clientName: 'Rice Ruffles',
      dateTime: new Date(1622807656000).toISOString(),
      quoteReference: '26378e76-c96e-4f1f-ad1e-a3596e1680d7',
      bookingReference: '26378e76-c96e-4f1f-ad1e-a3596e1680d7',
      openTasks: 'In Custody',
      assignee: 'Assignee Name7',
    },
    {
      clientName: 'Samuel Kilroy',
      dateTime: new Date(1629193963000).toISOString(),
      quoteReference: '555fa3b2-daac-4513-b605-97907a55a687',
      bookingReference: '555fa3b2-daac-4513-b605-97907a55a687',
      openTasks: 'Snakes and Earrings (Hebi ni piasu)',
      assignee: 'Assignee Name8',
    },
    {
      clientName: 'Olenka Marjanski',
      dateTime: new Date(1637382848000).toISOString(),
      quoteReference: '2c46a6f8-d236-4f85-98d3-cdf00ebf834c',
      bookingReference: '2c46a6f8-d236-4f85-98d3-cdf00ebf834c',
      openTasks: 'Sphinx',
      assignee: 'Assignee Name9',
    },
    {
      clientName: 'Coralie Feltoe',
      dateTime: new Date(1633581545000).toISOString(),
      quoteReference: '',
      bookingReference: '3267bb99-a52e-4319-8844-732eb73fd7d9',
      openTasks: 'Adventures of Sharkboy and Lavagirl 3-D, The',
      assignee: 'Assignee Name10',
    },
    {
      clientName: 'Rossy Spargo',
      dateTime: new Date(1611421153000).toISOString(),
      quoteReference: 'b6def10d-abf4-4bfc-9b79-76cae2e23f0e',
      bookingReference: 'b6def10d-abf4-4bfc-9b79-76cae2e23f0e',
      openTasks: 'Hider in the House',
      assignee: 'Assignee Name11',
    },
    {
      clientName: 'Doralin Manuaud',
      dateTime: new Date(1636633684000).toISOString(),
      quoteReference: '59be6905-a226-4db9-973f-9eabce7a15ad',
      bookingReference: '',
      openTasks: 'Coriolanus',
      assignee: 'Assignee Name12',
    },
    {
      clientName: 'Alf Barthel',
      dateTime: new Date(1641449548000).toISOString(),
      quoteReference: '',
      bookingReference: 'bc5efa41-0d3f-4979-b19b-8b55c09c51f6',
      openTasks: 'United 93',
      assignee: 'Assignee Name13',
    },
    {
      clientName: 'Giffard Cossell',
      dateTime: new Date(1613526400000).toISOString(),
      quoteReference: '4f45213c-be75-4b6d-988a-9ec05e025283',
      bookingReference: '4f45213c-be75-4b6d-988a-9ec05e025283',
      openTasks: "The Emperor's Club",
      assignee: 'Assignee Name14',
    },
    {
      clientName: 'Olia Iannitti',
      dateTime: new Date(1626253710000).toISOString(),
      quoteReference: '449329a8-8649-423e-96e9-12ea86963882',
      bookingReference: '449329a8-8649-423e-96e9-12ea86963882',
      openTasks: 'Spirit Trap',
      assignee: 'Assignee Name15',
    },
    {
      clientName: 'Bea Boundley',
      dateTime: new Date(1636301597000).toISOString(),
      quoteReference: '',
      bookingReference: 'f7f373c8-4ca0-4140-94ba-e1655a8de1af',
      openTasks: 'Batman: The Dark Knight Returns, Part 2',
      assignee: 'Assignee Name16',
    },
    {
      clientName: 'Bobette Fuggles',
      dateTime: new Date(1630215454000).toISOString(),
      quoteReference: '',
      bookingReference: '72d01b29-665f-4f62-9a40-48adbdfc3ccd',
      openTasks: 'Young Master, The (Shi di chu ma)',
      assignee: 'Assignee Name17',
    },
    {
      clientName: 'Darcey Dymott',
      dateTime: new Date(1639803128000).toISOString(),
      quoteReference: '',
      bookingReference: '15283555-403e-42be-a70a-794d9890c1f0',
      openTasks: 'Swamp Women',
      assignee: 'Assignee Name18',
    },
    {
      clientName: 'Ernie Clopton',
      dateTime: new Date(1629371653000).toISOString(),
      quoteReference: 'c3eac535-1ad9-4f65-8d02-d62e4998ae2f',
      bookingReference: 'c3eac535-1ad9-4f65-8d02-d62e4998ae2f',
      openTasks: 'Amanece, que no es poco',
      assignee: 'Assignee Name19',
    },
    {
      clientName: 'Brendon Bittlestone',
      dateTime: new Date(1635788493000).toISOString(),
      quoteReference: '',
      bookingReference: '25005157-7be5-4660-8b72-af0b0baa44a6',
      openTasks: 'Weather Man, The',
      assignee: 'Assignee Name20',
    },
    {
      clientName: 'Gerick Hickenbottom',
      dateTime: new Date(1633666110000).toISOString(),
      quoteReference: 'ff9c1d86-3267-4326-997f-cd39290d9f41',
      bookingReference: 'ff9c1d86-3267-4326-997f-cd39290d9f41',
      openTasks: "General's Daughter, The",
      assignee: 'Assignee Name21',
    },
    {
      clientName: 'Ryann Wood',
      dateTime: new Date(1613170815000).toISOString(),
      quoteReference: 'a91d0f13-59e7-456a-af0a-279c984df71b',
      bookingReference: '',
      openTasks: 'Black Legion',
      assignee: 'Assignee Name22',
    },
    {
      clientName: 'Blondie MacKean',
      dateTime: new Date(1632103187000).toISOString(),
      quoteReference: '',
      bookingReference: '34de92ed-429d-4e74-9c19-29b165dfafc7',
      openTasks: 'Non-Stop',
      assignee: 'Assignee Name23',
    },
    {
      clientName: 'Keely Metcalf',
      dateTime: new Date(1637921673000).toISOString(),
      quoteReference: '05a3d4d0-bed8-43a7-95a5-671b0e2bb659',
      bookingReference: '',
      openTasks: 'Enduring Love',
      assignee: 'Assignee Name24',
    },
    {
      clientName: 'Lowrance Bruggen',
      dateTime: new Date(1638204255000).toISOString(),
      quoteReference: '',
      bookingReference: 'b0d4fd16-5879-47a0-82a6-8df0f91d6e26',
      openTasks: 'Goodbye Uncle Tom',
      assignee: 'Assignee Name25',
    },
    {
      clientName: 'Kaela Gaven',
      dateTime: new Date(1624298226000).toISOString(),
      quoteReference: '775ae7c3-ced5-4761-aec8-c8a25f43d9c3',
      bookingReference: '',
      openTasks: 'Splinterheads',
      assignee: 'Assignee Name26',
    },
    {
      clientName: 'Celestia Spering',
      dateTime: new Date(1615827850000).toISOString(),
      quoteReference: '',
      bookingReference: 'ab258af1-e0f4-4e13-b9fa-75b75d352e9f',
      openTasks: 'Beer Wars',
      assignee: 'Assignee Name27',
    },
    {
      clientName: 'Brynne Fulmen',
      dateTime: new Date(1621321800000).toISOString(),
      quoteReference: 'e256021c-9564-40dc-bb19-6629d9d304fb',
      bookingReference: '',
      openTasks: 'Most Dangerous Game, The',
      assignee: 'Assignee Name28',
    },
    {
      clientName: 'Wilow Eland',
      dateTime: new Date(1622674025000).toISOString(),
      quoteReference: 'd93bbb53-1cd5-4802-b354-7a182f1b8157',
      bookingReference: '',
      openTasks: 'SubUrbia',
      assignee: 'Assignee Name29',
    },
    {
      clientName: 'Ebeneser Fance',
      dateTime: new Date(1629547740000).toISOString(),
      quoteReference: '8c39c331-201a-42ee-865c-9aa7b1c71c7d',
      bookingReference: '8c39c331-201a-42ee-865c-9aa7b1c71c7d',
      openTasks: 'Ask Me Anything',
      assignee: 'Assignee Name30',
    },
    {
      clientName: 'Gussy Van Halle',
      dateTime: new Date(1633125708000).toISOString(),
      quoteReference: '126f1467-1c20-4402-9cb6-345df922289d',
      bookingReference: '126f1467-1c20-4402-9cb6-345df922289d',
      openTasks: "Punk's Dead: SLC Punk! 2",
      assignee: 'Assignee Name31',
    },
    {
      clientName: 'Jo-ann Monahan',
      dateTime: new Date(1615592247000).toISOString(),
      quoteReference: 'e4109039-951d-4144-bc7c-a8142b4123f5',
      bookingReference: '',
      openTasks: 'Christine Jorgensen Story, The',
      assignee: 'Assignee Name32',
    },
    {
      clientName: 'Courtnay Nayshe',
      dateTime: new Date(1633838375000).toISOString(),
      quoteReference: '',
      bookingReference: '38258be9-d885-4950-a473-44396bbdb87b',
      openTasks: 'Death Wish',
      assignee: 'Assignee Name33',
    },
    {
      clientName: 'Ross Coombs',
      dateTime: new Date(1636048848000).toISOString(),
      quoteReference: '0e03cc71-3ef7-4d87-b33a-f033426f3b20',
      bookingReference: '0e03cc71-3ef7-4d87-b33a-f033426f3b20',
      openTasks: 'Tepenin Ardi',
      assignee: 'Assignee Name34',
    },
    {
      clientName: 'Elsinore Vance',
      dateTime: new Date(1622188947000).toISOString(),
      quoteReference: 'e7d9f7e5-ec39-4410-adf5-98f1fb2f9ab0',
      bookingReference: 'e7d9f7e5-ec39-4410-adf5-98f1fb2f9ab0',
      openTasks: 'The Amazing Dr. Clitterhouse',
      assignee: 'Assignee Name35',
    },
    {
      clientName: 'Meredeth Heggie',
      dateTime: new Date(1621275118000).toISOString(),
      quoteReference: '',
      bookingReference: '8de817dc-4fd1-45d9-9288-067873d4db83',
      openTasks: '84 Charing Cross Road',
      assignee: 'Assignee Name36',
    },
    {
      clientName: 'Lorne Armistead',
      dateTime: new Date(1621492733000).toISOString(),
      quoteReference: 'da6b6c84-8a80-4f2d-b151-92169eda68c9',
      bookingReference: '',
      openTasks: 'Carless Love',
      assignee: 'Assignee Name37',
    },
    {
      clientName: 'Carmon Romero',
      dateTime: new Date(1619834986000).toISOString(),
      quoteReference: 'd8259b81-c776-4b75-9651-ed829f4e3a25',
      bookingReference: '',
      openTasks: 'Playing the Victim (Izobrazhaya zhertvu)',
      assignee: 'Assignee Name38',
    },
    {
      clientName: 'Immanuel Chalke',
      dateTime: new Date(1633651437000).toISOString(),
      quoteReference: '',
      bookingReference: '6bf8af50-9b2f-4e93-8975-51d1c2ed8bb8',
      openTasks:
        'Irony of Fate, or Enjoy Your Bath! (Ironiya sudby, ili S legkim parom!)',
      assignee: 'Assignee Name39',
    },
    {
      clientName: 'Thorin Forsdike',
      dateTime: new Date(1629627704000).toISOString(),
      quoteReference: 'b7603232-6ed3-4a8f-b598-518ff1b9190e',
      bookingReference: '',
      openTasks: 'Rampo (a.k.a. The Mystery of Rampo)',
      assignee: 'Assignee Name40',
    },
  ],
};
